module.exports = __webpack_public_path__ + "img/bg2.d6502e25.png";